import addToCart from '@ynap/api-utils/src/cart/addToCart';
import createGuestIdentity from '@ynap/api-utils/src/identity/createGuestIdentity';
import ResponseError from '@ynap/api-utils/src/ResponseError';
import {
    ADD_TO_CART_REQUEST,
    ADD_TO_CART_SUCCESS,
    ADD_TO_CART_ERROR,
    NO_SIZE_SELECTED_ERROR,
    ADD_TO_CART_GENERIC_ERROR,
    ADD_TO_CART_IDENTITY_GENERIC_ERROR,
} from '../constants/ActionTypes';
import { notifyBasketChanged } from './common/siteFurnitureAPI';
import { SET_UBER_TOKEN, SET_UBER_TOKEN_ERROR, dispatchUserChangeEvent } from '@ynap/auth-state';

import { notificationActions } from '@ynap/notification-state';
import { getWatsonConfig, getShoppingBagPromptConfig } from '../selectors/getConfig';

const addToBag = (partNumber, params) => {
    const { setActionNotificationOnError = true, addToCartLoading, reservationId, includeShoppingCart, quantity = 1 } = params || {};

    return async (dispatch, getState, fetch, callback) => {
        //to cover wcs perf issue
        if (addToCartLoading) {
            return;
        }
        const state = getState();
        const watsonConfig = getWatsonConfig(state);
        const enableShoppingBagPrompt = getShoppingBagPromptConfig(state);
        let { uberToken } = watsonConfig;
        const { messages } = state.appState || state;
        const addToBagErrorMessage = messages.notifications.ADD_TO_BAG_MESSAGE_ERROR();
        const isGuestUser = !uberToken;

        if (!partNumber) {
            return dispatch({ type: NO_SIZE_SELECTED_ERROR });
        }

        dispatch({ type: ADD_TO_CART_REQUEST });

        if (isGuestUser) {
            const guestIdentityRequest = createGuestIdentity(watsonConfig);
            try {
                const response = await fetch(guestIdentityRequest, { method: 'POST' });
                if (!response.ok) {
                    throw new ResponseError(response);
                }
                const json = await response.json();

                uberToken = json.Ubertoken;
                // Set uberToken app-wide
                dispatch({ type: SET_UBER_TOKEN, uberToken });
            } catch (error) {
                dispatch({ type: SET_UBER_TOKEN_ERROR, error });
                // We are returning out so need to cancel the ADD_TO_CART_REQUEST
                dispatch({
                    type: ADD_TO_CART_ERROR,
                    partNumber,
                    error: { errorKey: ADD_TO_CART_IDENTITY_GENERIC_ERROR },
                });
                return;
            }
        }

        try {
            return await dispatch(
                addToBagWithUberToken(
                    { ...watsonConfig, partNumber, uberToken, quantity, reservationId, includeShoppingCart },
                    setActionNotificationOnError,
                    addToBagErrorMessage,
                    messages,
                    isGuestUser,
                    callback,
                    enableShoppingBagPrompt,
                ),
            );
        } catch (error) {
            return dispatch({
                type: ADD_TO_CART_ERROR,
                partNumber,
                error: { errorKey: ADD_TO_CART_GENERIC_ERROR },
            });
        }
    };
};

export const addToBagWithUberToken =
    (params, setActionNotificationOnError, addToBagErrorMessage, messages, isGuestUser, callback, enableShoppingBagPrompt = false) =>
    async (dispatch, getState, fetch) => {
        const { includeShoppingCart } = params;
        const addToCartRequest = addToCart(params);

        try {
            const response = await fetch(addToCartRequest, { errorTags: ['addToCartError'] });

            const json = await response.json();
            if (response.status === 400) {
                const { errors = [] } = json;
                let key = 'ADD_TO_CART_GENERIC_ERROR';
                if (errors.length > 0) {
                    key = errors[0].errorKey;
                }
                const definedErrorMessage = messages?.notifications?.errors({ error: key });
                const genericErrorMessage = messages?.notifications?.errors({});

                if (setActionNotificationOnError === true) {
                    dispatch(
                        notificationActions.setNotification({
                            name: 'action',
                            type: 'error',
                            message: definedErrorMessage && definedErrorMessage != genericErrorMessage ? definedErrorMessage : addToBagErrorMessage,
                        }),
                    );
                }
                return dispatch({
                    type: ADD_TO_CART_ERROR,
                    partNumber: params.partNumber,
                    error: { errorKey: key },
                });
            }

            if (!response.ok) {
                throw new ResponseError(response);
            }

            // user change event will also update basket
            isGuestUser
                ? dispatchUserChangeEvent(params.uberToken, enableShoppingBagPrompt ? params.partNumber : null)
                : notifyBasketChanged(includeShoppingCart, includeShoppingCart ? json : null, enableShoppingBagPrompt ? params.partNumber : null);
            callback && callback(json);
            return dispatch({ type: ADD_TO_CART_SUCCESS, lastAddedItem: params.partNumber });
            // doesn't cater for linked pids or bundles yet
        } catch (error) {
            throw error;
        }
    };

export default addToBag;
